import React from "react";
import './FooterTwo.css'
export default function FooterTwo() {
  return (
    <div className="footerTwo">
      <div className="f2r">
        <div className="f2rText">About Leverage</div>
        <ul className="f2rList">
          <li>About Us</li>
          <li>Work with Us</li>
          <li>Meet the team</li>
        </ul>
      </div>
      <div className="f2r">
        <div className="f2rText">About Leverage</div>
        <ul className="f2rList">
          <li>LOR</li>
          <li>SOP</li>
        </ul>
      </div>
      <div className="f2r">
        <div className="f2rText">About Leverage</div>
        <ul className="f2rList">
          <li>Study in UK</li>
          <li>Study in Canada</li>
          <li>Study in USA</li>
          <li>Study in Australia</li>
          <li>Study in New Zealand</li>
          <li>Study in Germany</li>
          <li>Study in Russia</li>
          <li>Study in China</li>
        </ul>
      </div>
      <div className="f2r">
        <div className="f2rText">About Leverage</div>
        <ul className="f2rList">
          <li>IELTS</li>
          <li>GMAT</li>
          <li>GRE</li>
          <li>SAT</li>
          <li>TOEFL</li>
          <li>PET</li>
        </ul>
      </div>
      <div className="f2r">
        <div className="f2rText">About Leverage</div>
        <ul className="f2rList">
          <li>AI Course Finder</li>
          <li>Leverage Live</li>
          <li>Scholarships</li>
          <li>Loans</li>
          <li>Forex</li>
          <li>Gobal Bank Account</li>
          <li>UniConnect</li>
          <li>LeverageTV</li>
        </ul>
      </div>
      <div className="f2r">
        <div className="f2rText">About Leverage</div>
        <ul className="f2rList">
          <li>Privacy Policy</li>
          <li>Terms & Conditions</li>
          <li>Sitemap</li>
        </ul>
      </div>
    </div>
  );
}
